import type { Currencies } from 'src/types/common/Currencies';

const SET_CURRENCIES = 'common/currency/SET_CURRENCIES';

export const setCurrencies = (currencies: Currencies) => ({ type: SET_CURRENCIES, currencies });

type CurrenciesAction = ReturnType<typeof setCurrencies>;

// eslint-disable-next-line @typescript-eslint/default-param-last
export default (currencies = {}, action: CurrenciesAction) => {
  switch (action.type) {
    case SET_CURRENCIES:
      return action.currencies;
    default:
      return currencies;
  }
};
